<template id="ability-input">
    <v-ons-page>
        <v-ons-toolbar>
            <div class="center">(ﾟДﾟ)</div>
            <div class="right">
                <v-ons-toolbar-button
                    icon="fa-cog"
                    @click="pushSettingHomePage"
                ></v-ons-toolbar-button>
            </div>
        </v-ons-toolbar>

        <div class="ability-input-area">
            <v-ons-row class="ability-row">
                <v-ons-col class="ability-col">
                    <input
                            class="input"
                            placeholder="特殊能力1を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(0)"
                            v-bind:value="abilities[0] ? abilities[0].name : ''"
                    />
                </v-ons-col>
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力2を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(1)"
                            v-bind:value="abilities[1] ? abilities[1].name : ''"
                    />
                </v-ons-col>
            </v-ons-row>

            <v-ons-row class="ability-row">
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力3を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(2)"
                            v-bind:value="abilities[2] ? abilities[2].name : ''"
                    />
                </v-ons-col>
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力4を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(3)"
                            v-bind:value="abilities[3] ? abilities[3].name : ''"
                    />
                </v-ons-col>
            </v-ons-row>

            <v-ons-row class="ability-row">
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力5を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(4)"
                            v-bind:value="abilities[4] ? abilities[4].name : ''"
                    />
                </v-ons-col>
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力6を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(5)"
                            v-bind:value="abilities[5] ? abilities[5].name : ''"
                    />
                </v-ons-col>
            </v-ons-row>

            <v-ons-row class="ability-row">
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力7を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(6)"
                            v-bind:value="abilities[6] ? abilities[6].name : ''"
                    />
                </v-ons-col>
                <v-ons-col class="ability-col">
                    <input
                            placeholder="特殊能力8を選択"
                            readonly="readonly"
                            v-on:click="pushListPage(7)"
                            v-bind:value="abilities[7] ? abilities[7].name : ''"
                    />
                </v-ons-col>
            </v-ons-row>
        </div>

        <div class="button_area">
            <v-ons-button
                    class="clear_button"
                    @click="clearAll"
            >ぜんぶけす</v-ons-button>
        </div>

        <effect-summary
                v-bind:user-abilities="abilities"
        ></effect-summary>

    </v-ons-page>
</template>

<script>
    import abilityList from './AbilityList'
    import effectSummary from './EffectSummary'
    import settingHome from './SettingHome'

    export default {
        name: "AbilityInput.vue",
        components: {
            effectSummary
        },
        created() {
            this.$ga.page('/AbilityInput')
        },
        methods: {
            pushListPage(index) {
                // TODO: いきなりcommitするのではなく、vuex側にactionを用意してそちらからcommitするべき？
                this.$store.commit('setTargetIndex', index);
                this.$emit('push-page', abilityList)
            },
            pushSettingHomePage() {
                this.$emit('push-page', settingHome)
            },
            clearAll() {
                this.$store.commit('clearAllUserAbility');

                this.$db.working.put({
                    id: 1,
                    abilities: JSON.stringify(this.$store.state.userAbilities)
                });
            }
        },
        data() {
            return {
                abilities: this.$store.state.userAbilities
            }
        }
    }
</script>

<style scoped>
    .ability-input-area {
        margin-bottom: 3vh;
    }

    .ability-input-area .ability-row {
        height: 8vh;
    }

    .ability-input-area .ability-col {
        margin: 1vw;
        border: thin lightgray solid;
        -webkit-border-radius: 0.5em;
        -moz-border-radius: 0.5em;
        border-radius: 0.5em;
    }

    .ability-input-area .ability-col div {
        width: 100%;
        height: 100%;
    }

    .ability-col input {
        height: 100%;
        width: 95%;
        outline: 0;
        border: 0;
        background: transparent;
        font-size: 1.0em;
    }

    .button_area {
        margin-bottom: 3vh;
    }
</style>
